import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { getPrefix } from "features/Application/slices/models";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums/reducer";
import { fetchLimitedAccountInfo } from "features/Accounts/EditAccount/state/thunks/limitedAccountInfoThunk";
import { type ResponseError } from "types";

type LimitedAccountInfoState = {
  id: number;
  name: string;
  tags: string[];
  isLoading: boolean;
  logoUri: string;
  error: ResponseError | null;
};

const initialState: LimitedAccountInfoState = {
  id: 0,
  name: "",
  tags: [] as string[],
  logoUri: "",
  isLoading: false,
  error: null,
};

const limitedAccountInfoSlice = createSlice({
  name: getPrefix({
    namespace: ReducerNamespaceTypes.Accounts,
    entity: ReducerEntityPrefixTypes.EditAccount,
    name: "limitedAccount",
  }),
  initialState,
  reducers: {
    setLimitedAccountInfo: (state, action: PayloadAction<LimitedAccountInfoState["tags"]>) => {
      state.tags = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLimitedAccountInfo.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchLimitedAccountInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.tags = action.payload.tags;
        state.name = action.payload.name;
        state.id = action.payload.id;
        state.logoUri = action.payload.logoUri;
        state.error = null;
      })
      .addCase(fetchLimitedAccountInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload ?? null;
      });
  },
});

export const { setLimitedAccountInfo } = limitedAccountInfoSlice.actions;

export default limitedAccountInfoSlice.reducer;
